import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Skip if returning from OAuth callback - AuthCallback handles it
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('dd_token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const registerCustomer = async (data) => {
    const res = await api.post('/auth/register/customer', data);
    localStorage.setItem('dd_token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const registerInterpreter = async (data) => {
    const res = await api.post('/auth/register/interpreter', data);
    localStorage.setItem('dd_token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (err) {
      // Ignore logout API errors - we still clear local state
      if (process.env.NODE_ENV === 'development') {
        console.warn('Logout API call failed (clearing local state anyway):', err?.message);
      }
    }
    localStorage.removeItem('dd_token');
    setUser(null);
  };

  const value = { user, loading, login, logout, registerCustomer, registerInterpreter, refresh: checkAuth, setUser };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
